/**
 * manageCfg.roleManage.permissionAssignment Module
 *
 * Description
 */
'use strict';
angular.module('manageCfg.roleManageMent.permissionAssignment.editingCenter', [
    'iwoPermissionAssignment',
    'newspaperPermissionAssignment',
    'websitePermissionAssignment',
    'wechatPermissionAssignment',
    'weiboPermissionAssignment',
    'appPermissionAssignmentModule',
    'privilegeTakingModule',
    'tvPermissionAssignment',
    'broadCastPermissionAssignment',
    'trillPermissionAssignment',
    'baijiahaoPermissionAssignment',
    'qiehaoPermissionAssignment',
    'toutiaoPermissionAssignment',
    'kuaishouPermissionAssignment'
]);
